import styled from "styled-components";
import {FreeToPlayIconPositionDefaultBox} from "./free-to-play-icon-position.default.box";

export const FreeToPlayIconPositionMrGreenBox = styled(FreeToPlayIconPositionDefaultBox)`
    background-image: radial-gradient(farthest-side at 57% 95%, ${({theme}) => theme.colors.brandPrimary}, ${({theme}) => theme.colors.brandPrimary} 34%,transparent);
    padding: ${({shouldOffsetIcon}) => shouldOffsetIcon ? "5px 10px 10px 25px" : "5px 5px 5px 25px"};
    box-sizing: content-box;
`;
